import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--label-primary)";

function IconEdit({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} fill-rule="evenodd" d="m5.053 13.598 7.714-7.714-2.651-2.651-7.715 7.714-.994 3.646 3.646-.995zm8.472-8.472 1.326-1.325a.268.268 0 0 0 0-.379l-2.273-2.273a.268.268 0 0 0-.379 0l-1.325 1.326 2.651 2.651zm2.083-.568L5.76 14.406a.261.261 0 0 1-.115.068L.342 15.99a.268.268 0 0 1-.332-.331l1.515-5.303a.267.267 0 0 1 .069-.115L11.442.392a1.34 1.34 0 0 1 1.894 0l2.272 2.272a1.34 1.34 0 0 1 0 1.894z"/>
        </svg>
    );
}

export default IconEdit;
